import PerformanceGaps from "@/components/gps/PerformanceGaps";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function MyPerformance() {
  return (
    <div className="space-y-8 kw-fade-up" data-testid="my-performance-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="kw-overline mb-2">GPS vs atividade real</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter">
            O meu <span className="text-[#E50000]">desempenho</span>
          </h1>
          <p className="text-sm text-[#A3A3A3] mt-2 max-w-3xl">
            O que fizeste face ao ritmo que o teu GPS exige — na semana, no mês e no ano. A barra compara com o
            esperado até hoje; se estiveres atrás, mostro quanto falta por dia útil para recuperares.
          </p>
        </div>
        <Link to="/my-profile#gps" className="kw-btn-secondary !py-2 !px-4 text-xs inline-flex items-center gap-2"
          data-testid="performance-edit-gps">O meu GPS <ArrowRight className="w-3 h-3" /></Link>
      </div>
      <PerformanceGaps />
    </div>
  );
}
